let idCounter = 0;


export function uniqueId(prefix = '') {
  const id = ++idCounter;
  return prefix + id;
}



// WEBPACK FOOTER //
// ./src/shared/helpers/uniqueId.js